import { TTLCache } from '@brokerloop/ttlcache';
import CONSTANTS from '../constants/constants';

const isInTest = typeof global.it === 'function';

interface ITtlStorage<T> {
  get: (key: string) => T;
  set: (key: string, value: T) => void;
  has: (key: string) => boolean;
}

const ttlStorage = {
  create<T>(): ITtlStorage<T> {
    const storage = new TTLCache<string, T>({
      ttl: isInTest ? parseInt(process.env.SPC_OVERRIDE_CACHE_TTL, 10) : CONSTANTS.CACHE_TTL,
      clock: Date,
    });

    return {
      get: (key: string): T => storage.get(key),
      set: (key: string, value: T): void => storage.set(key, value),
      has: (key: string): boolean => storage.has(key) && storage.get(key) !== undefined,
    };
  },
};

export default ttlStorage;
